module.exports = __webpack_public_path__ + "static/mike-bio-d81ed388d156b869031fd008ad73189b.jpg";